import request from '@/api/request'

/**
 * 获取轮播图
 */
export const getSwiperList = (params) => {
    return request({
        url: '/radioweb/adm/rotationPicture/getListPage',
        params,
        method: 'get'
    })
}
/**
 * 启用、停用轮播图
 */
export const stateSwiper = (id) => {
    return request({
        url: `/radioweb/adm/rotationPicture/updateState?id=${id}`,
        data: {},
        method: 'post'
    })
}
/**
 * 添加轮播图
 */

export const addSwiper = (data) => {
    return request({
        url: '/radioweb/adm/rotationPicture/addRotationPicture',
        data: data,
        method: 'post',
        type: 'json'
    })
}
/**
 * 更新轮播图
 */

export const updateSwiper = (data) => {
    return request({
        url: '/radioweb/adm/rotationPicture/updateRotationPicture',
        data: data,
        method: 'post',
        type: 'json'
    })
}
/**
 * 删除
 */
export const delSwiper = (id) => {
    return request({
        url: `/radioweb/adm/rotationPicture/delRotationPicture?id=${id}`,
        data: {},
        method: 'post'
    })
}